import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { Box } from "@gemini/core";
import { useIsIntersecting, useTestId, useBrandUrl } from "@/hooks";
import { SimilarListingsCarousel } from "@/components/SimilarListings/SimilarListingsCarousel";
import { fetchSimilarListings } from "@/api/fetchSimilarListings";
import { useSimilarListings } from "@/components/SimilarListings/useSimilarListings";
import { SIMILAR_LISTING_PATH } from "@/constants/api";
import { useClassifiedId } from "@/contexts/classified";
export const SimilarListings = () => {
    const { similarListings, similarRecords, isDisplayed, isFetched, setSimilarListingsData, } = useSimilarListings();
    const { isIntersecting } = useIsIntersecting({
        elementId: "similarListings",
        triggerOnce: true,
        rootMargin: "1280px",
    });
    const classifiedId = useClassifiedId();
    const similarListingsUrl = useBrandUrl({
        endpoint: SIMILAR_LISTING_PATH(classifiedId),
    });
    const testId = useTestId("SimilarListings");
    useEffect(() => {
        if (!isFetched && !isDisplayed && isIntersecting && classifiedId) {
            fetchSimilarListings(similarListingsUrl).then((data) => {
                setSimilarListingsData(data);
            });
        }
    }, [
        isFetched,
        isDisplayed,
        isIntersecting,
        similarListingsUrl,
        setSimilarListingsData,
        classifiedId,
    ]);
    return (_jsx(Box, { as: "section", id: "similarListings", testId: testId, gridColumn: {
            "breakpoint.base": "col-start / span 4",
            "breakpoint.md": "col-start / span 4",
            "breakpoint.lg": "col-start / span 12",
            "breakpoint.sm": "col-start / span 8",
            "breakpoint.xl": "col-start 1 / span 12",
            "breakpoint.xxl": "col-start 2 / span 10",
        }, marginBottom: {
            "breakpoint.lg": "spacing.16",
        }, overflow: "clip", position: "relative", unsafe_className: "HideOnPrint", children: _jsx(SimilarListingsCarousel, { similarListings: similarListings, similars: similarRecords, display: isDisplayed }) }));
};
